export default __webpack_public_path__ + "static/1302-3cb2d80b7dec64b067d1701133a49df5.gif";